import React, { useState } from 'react';
import PropTypes from 'prop-types';
import Box from '@mui/material/Box';
import Typography from '@mui/material/Typography';
import Modal from '@mui/material/Modal';
import { Grid } from '@mui/material';
import { Button, Input, Textarea } from '../../../../../../components';
import './ModalNotification.scss';

const style = {
  position: 'absolute',
  top: '50%',
  left: '50%',
  transform: 'translate(-50%, -50%)',
  width: 750,
  bgcolor: 'background.paper',
  boxShadow: 24,
  borderRadius: 5,
  p: 4,
};

function ModalNotificationSMS({ open, title, event, handleClose, onSave }) {
  const [message, setMessage] = useState('');

  return (
    <Modal
      open={open}
      onClose={handleClose}
      aria-labelledby="modal-modal-title"
      aria-describedby="modal-modal-description">
      <Box sx={style}>
        <Typography id="modal-modal-title" variant="h6" component="h2">
          {title}
        </Typography>
        <Grid container marginTop={2} justifyContent="center">
          <Grid sm={10}>
            <label style={{ color: 'gray', fontWeight: 'bold' }}>Event </label>
            <b className="event-notification-label">{event.name}</b>
          </Grid>
        </Grid>
        <Grid container marginTop={3} justifyContent="start">
          <Grid sm={9} marginLeft={10}>
            <label style={{ color: 'gray', fontWeight: 'bold' }}>Message</label>
            <Textarea
              type="text"
              value={message}
              placeholder="Type message"
              onChange={(e) => setMessage(e.target.value)}
            />
          </Grid>
        </Grid>
        <Grid container justifyContent="center">
          <Grid sm={9}>
            <p className="event-notificacion-message-hint">
              * This message will be sent to all vendors registered for this event by SMS.
            </p>
          </Grid>
        </Grid>
        <Grid container justifyContent="space-evenly" marginTop={2}>
          <Grid sm={3}>
            <Button outline label="Cancel" onClick={() => handleClose()} />
          </Grid>
          <Grid sm={3}>
            <Button label="Send" onClick={() => onSave(message, event.id)} />
          </Grid>
        </Grid>
      </Box>
    </Modal>
  );
}

ModalNotificationSMS.defaultProps = {};

ModalNotificationSMS.propTypes = {
  open: PropTypes.bool.isRequired,
  title: PropTypes.string.isRequired,
  handleClose: PropTypes.func.isRequired,
  onSave: PropTypes.func.isRequired,
  // eslint-disable-next-line react/forbid-prop-types
  event: PropTypes.any.isRequired,
};

export default ModalNotificationSMS;
